import { useEffect } from 'react';

import { logEvent } from '../../utils/eventLog';

export type PrintMode = 'single' | 'batch';

export function recordReportViewed(): void {
  void logEvent('progress_report.viewed.v1').catch(() => {});
}

export function usePrintRecorder(mode: PrintMode, reports: number): void {
  useEffect(() => {
    if (reports <= 0) return;
    let open = false;
    const onBeforePrint = () => {
      if (open) return;
      open = true;
      void logEvent('progress_report.printed.v1', { mode, reports: String(reports) }).catch(() => {});
    };
    const onAfterPrint = () => {
      open = false;
    };
    window.addEventListener('beforeprint', onBeforePrint);
    window.addEventListener('afterprint', onAfterPrint);
    return () => {
      window.removeEventListener('beforeprint', onBeforePrint);
      window.removeEventListener('afterprint', onAfterPrint);
    };
  }, [mode, reports]);
}
